<template>
  <div class="c-quick-access">
    <div class="c-quick-access__title">快捷入口</div>
    <div class="c-quick-access__warp">
      <div
        v-for="(item, index) in accessList"
        :key="index"
        class="c-quick-access__item"
        @click="gotoAccess(item)"
      >
        <div class="c-quick-access__item__content">
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    goToPersonalCenter: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      accessList: [
        {
          label: '修改手机号',
          enterPath: '/personal-center/account-setting.html?type=phone',
        },
        {
          label: '修改密码',
          enterPath: '/personal-center/account-setting.html?type=password',
        },
        {
          label: '修改邮箱',
          enterPath: '/personal-center/account-setting.html?type=email',
        },
        {
          label: '查看我的权益',
          enterPath: '/personal-center/equity.html',
        },
        {
          label: '查看我的工作日志',
          enterPath: '/performance-evaluation/worklog-list.html',
        },
        {
          label: '查看我的行权记录',
          enterPath: '/personal-center/exercise-list.html',
        }
      ]
    }
  },
  methods: {
    gotoAccess(item) {
      this.goToPersonalCenter(item.enterPath)
    }
  }
}
</script>

<style lang="scss">
.c-quick-access {
  padding: 26px 10px;
  background-color: #fff;
  .c-quick-access__title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 26px;
    padding: 0 16px;
  }
  .c-quick-access__warp {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    margin-bottom: -26px;
  }
  .c-quick-access__item {
    margin-bottom: 26px;
    width: 33%;
    padding: 0 8px;
    line-height: 44px;
    .c-quick-access__item__content {
      border-radius: 4px;
      cursor: pointer;
      text-align: center;
      background-color: #ecf2f9;
    }
  }
}
</style>
